import { render, staticRenderFns } from "./RegionalInfo.vue?vue&type=template&id=3b7c886c&scoped=true&"
import script from "./RegionalInfo.vue?vue&type=script&lang=js&"
export * from "./RegionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegionalInfo.vue?vue&type=style&index=0&id=3b7c886c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c886c",
  null
  
)

export default component.exports